import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoGradjanskoProcesnoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom
        title="Početna"
        subtitle="Međunarodno građansko procesno pravo"
      />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Međunarodno građansko procesno pravo
              </h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno Građansko Procesno
                Pravo
              </p>
              <p>
                <strong>Nastavnik:</strong> Đuro Đurić
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Međunarodno građansko procesno pravo ima za cilj da
                studenti prošire teorijska i praktična znanja iz oblasti
                međunarodnog pravosuđa. Ova znanja se naročito odnose na pravila
                postupka na osnovu kojih se odlučuje u građanskopravnim
                sporovima Evropskog suda za ljudska prava, Evropskog suda pravde
                i ostalih međunarodnih sudova sa posebnim akcentom na pomenute.
                S obzirom na činjenicu da sve veći broj domaćih slučajeva
                završava pred Evropskim sudom za ljudska prava uz tendenciju
                rasta, akcenat praktičnog dijela će biti na pisanju predstavki
                pred međunarodnim sudovima. Takođe, cilj ovog predmeta je i da
                pomogne harmonizaciju međunarodnog procesnog prava, naročito
                evropskog, sa domaćim procesnim normama.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon polaganja ispita student će steći znanja da: utvrdi i
                objasni osnovne pojmove međunarodnog procesnog prava, izdvoji i
                objasni načela postupka, diskutuje i kritički posmatra ulogu i
                djelovanje međunarodnih sudova, analizira pravno dejstvo presuda
                međunarodnih sudova na pravni sistem Crne Gore, samostalno vrši
                istraživanja u ovoj oblasti, prepozna i objasni razlike između
                uporednih i domaćih zakonskih rješenja, istražuje i koristi
                literaturu na stranom jeziku, prepozna i objasni odnos
                normiranog prava i njegove primjene u praksi, zastupa, objasni i
                opravda svoja stanovišta, kao i argumentovano pobija navode
                suprotne strane.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong> Izvori međunarodnog
                procesnog prava; načela međunarodnog procesnog prava;
                Međunarodni sud pravde: Osnivanje; Izbor sudija; Organizaciona
                struktura; Nadležnost; Postupak pred Sudom; Pokretanje postupka;
                Incidentni postupci; Pismena i usmena faza postupka pred Sudom;
                Postupak pred vijećima; Okončanje postupka; Savjetodavno
                mišljenje Međunarodnog suda pravde; Evropski sud za ljudska
                prava: Osnovna načela postupka pred Evropskim sudom za ljudska
                prava; Učesnici u postupku; Podnosilac predstavke; Zastupnik
                pred Evropskim sudom za ljudska prava; Uslovi za dopuštenost
                predstavke; Troškovi postupka i pravna pomoć; Privremene mjere;
                Postupak za davanje savjetodavnih mišljenja; Saradnja
                nacionalnih sudova sa međunarodnim sudovima; Zaštita od pravnih
                akata međunarodnih institucija; Jezik postupka; Troškovi
                postupka pred međunarodnim sudovima; Pravni lijekovi; Izvršenje
                i objavljivanje odluka međunarodnih sudova.
              </p>
              <p>
                <strong>Praktična nastava:</strong> Praktična nastava se obavlja
                na predavanjima i vježbama kroz upoznavanje sa sudskom praksom i
                njenom analizom od strane studenata. Na fakultetu će se
                organizovati predavanja eminentnih stručnjaka iz ove oblasti
                kako bi studentima približili kako pravosuđe funkcioniše i kako
                bi ih upoznali sa slučajevima iz prakse koja je vrlo bogata.
                Pisanje pismena pred međunarodnim sudovima.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja, diskusije, izradu samostalnih
                istraživačkih radova – seminarskih radova, upoznavanje sa
                sudskom praksom crnogorskih sudova (u sudu / ili u okviru
                nastave na fakultetu) i analizu sudske prakse od strane
                studenata.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 1V</td>
                    <td>
                      Izvori međunarodnog procesnog prava; načela međunarodnog
                      procesnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 1V</td>
                    <td>Međunarodni sud pravde: Osnivanje; Izbor sudija</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 1V</td>
                    <td>Organizaciona struktura; Nadležnost</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 1V</td>
                    <td>
                      Postupak pred Sudom; Pokretanje postupka; Incidentni
                      postupci; Pismena i usmena faza postupka pred Sudom
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 1V</td>
                    <td>
                      Postupak pred vijećima; Okončanje postupka; Savjetodavno
                      mišljenje Međunarodnog suda pravde
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 1V</td>
                    <td>
                      Evropski sud za ljudska prava: Osnovna načela postupka
                      pred Evropskim sudom za ljudska prava
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 1V</td>
                    <td>Učesnici u postupku; Podnosilac predstavke</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 1V</td>
                    <td>
                      Zastupnik pred Evropskim sudom za ljudska prava; Uslovi za
                      dopuštenost predstavke
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 1V</td>
                    <td>
                      Troškovi postupka i pravna pomoć; Privremene mjere;
                      Postupak za davanje savjetodavnih mišljenja
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 1V</td>
                    <td>
                      Saradnja nacionalnih sudova sa međunarodnim sudovima
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Zaštita od pravnih akata međunarodnih institucija; Jezik
                      postupka
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 1V</td>
                    <td>
                      Troškovi postupka pred međunarodnim sudovima; Pravni
                      lijekovi
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 1V</td>
                    <td>
                      Izvršenje i objavljivanje odluka međunarodnih sudova
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoGradjanskoProcesnoPravoPM;
